webpackJsonp([96961042003272],{

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(9);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _breakpoints = __webpack_require__(18);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _workListItem = __webpack_require__(46);
	
	var _workListItem2 = _interopRequireDefault(_workListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductList = _glamorous2.default.ul({
	    listStyleType: "none",
	    marginLeft: "0"
	});
	
	var WorkList = function (_React$Component) {
	    _inherits(WorkList, _React$Component);
	
	    function WorkList(props) {
	        _classCallCheck(this, WorkList);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    WorkList.prototype.render = function render() {
	        return _react2.default.createElement(
	            ProductList,
	            null,
	            this.props.products.edges.map(function (_ref) {
	                var node = _ref.node;
	                return _react2.default.createElement(_workListItem2.default, {
	                    key: node.id,
	                    photo: node.photos[0].file.url,
	                    description: node.photos[0].description,
	                    title: node.title,
	                    slug: node.fields.slug
	                });
	            })
	        );
	    };
	
	    return WorkList;
	}(_react2.default.Component);
	
	exports.default = WorkList;
	module.exports = exports["default"];

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _g$li;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _glamorous = __webpack_require__(9);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _glamor = __webpack_require__(16);
	
	var _breakpoints = __webpack_require__(18);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StyledWorkListItem = _glamorous2.default.li((_g$li = {
	    position: "relative"
	}, _g$li[_breakpoints2.default.TabletUp] = {
	    margin: "1em",
	    paddingBottom: "1em",
	    maxWidth: "calc(50% - 2em)",
	    overflow: "hidden",
	    float: "left",
	    marginLeft: "0",
	    transition: "all 0.25s linear",
	    ':nth-child(2n)': {
	        float: "right",
	        marginRight: "0",
	        marginLeft: "0"
	    },
	    ':after': {
	        content: " ",
	        background: "linear-gradient(to right, rgba(193,239,220,1) 0%,rgba(171,239,190,0) 100%)",
	        position: "absolute",
	        top: "0",
	        left: "0",
	        width: "0",
	        height: "100%",
	        transition: "all 0.15s ease-in-out",
	        pointerEvents: "none"
	    },
	    ':hover': {
	        opacity: "0.75"
	        /*':hover:after': {
	            width: `100%`,
	            animation: `${css.keyframes({
	                '0%': { transform: `translateX(0)` },
	                '100%': { transform: `translateX(-15%)` }
	            })} 1s infinite ease-in-out alternate`
	        }*/
	    } }, _g$li));
	
	var WorkListItem = function (_React$Component) {
	    _inherits(WorkListItem, _React$Component);
	
	    function WorkListItem(props) {
	        _classCallCheck(this, WorkListItem);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            //maxWidth: Math.floor(Math.random() * 50) + 20 + '%',
	            marginTop: Math.random() * 5 + 1 + 'em'
	        };
	        return _this;
	    }
	
	    WorkListItem.prototype.render = function render() {
	        return _react2.default.createElement(
	            StyledWorkListItem,
	            { style: { marginTop: this.state.marginTop } },
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                    to: "/work/" + this.props.slug
	                },
	                _react2.default.createElement(
	                    "figure",
	                    null,
	                    _react2.default.createElement("img", { src: this.props.photo, alt: this.props.description }),
	                    _react2.default.createElement(
	                        "figcaption",
	                        null,
	                        _react2.default.createElement(
	                            "h3",
	                            null,
	                            this.props.title
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return WorkListItem;
	}(_react2.default.Component);
	
	exports.default = WorkListItem;
	module.exports = exports["default"];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _g$h, _g$div;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(9);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _breakpoints = __webpack_require__(18);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _productList = __webpack_require__(45);
	
	var _productList2 = _interopRequireDefault(_productList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _glamorous2.default.h2((_g$h = {
	    textAlign: 'center',
	    fontSize: "1em",
	    textTransform: "uppercase"
	}, _g$h[_breakpoints2.default.TabletUp] = {
	    textAlign: 'left',
	    position: 'absolute',
	    top: '0',
	    left: '0',
	    minWidth: "10em"
	}, _g$h));
	var ContentContainer = _glamorous2.default.div((_g$div = {}, _g$div[_breakpoints2.default.TabletUp] = {
	    position: 'relative',
	    paddingLeft: "10em",
	    paddingRight: "10em",
	    paddingBottom: "2em"
	}, _g$div));
	var Aside = _glamorous2.default.aside({
	    borderTop: "2px solid black",
	    paddingTop: "1em"
	});
	
	exports.default = function (_ref) {
	    var data = _ref.data;
	
	    var post = data.contentfulPage;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "article",
	            null,
	            _react2.default.createElement(
	                ContentContainer,
	                null,
	                _react2.default.createElement(
	                    Title,
	                    null,
	                    post.title ? post.title : null
	                ),
	                post.content !== null ? _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: post.content.childMarkdownRemark.html } }) : null
	            )
	        ),
	        _react2.default.createElement(
	            Aside,
	            null,
	            _react2.default.createElement(_productList2.default, { products: data.allContentfulWork })
	        )
	    );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-dd7ce71080a47627eae5.js